import { Box, Slider, Stack, Typography } from '@mui/material';
import { MprcRequestIndicator } from 'components';
import { ButtonConfirm } from 'components/buttons';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';

interface IProps {
    devPlanItemId: string;
    currentProgress?: number;
    readonly: boolean;
    onReload?: () => void;
}

export const UpdateOtherActivityProgress = ({ devPlanItemId, progress, onClose }: { devPlanItemId: string, progress: number, onClose: (success: boolean) => void; }) => {

    const api = useCoreApi();

    useEffect(() => {
        api.v1.devPlan.updateOtherActivityProgress({ devPlanItemId, progressPercent: progress ?? 0 })
            .then(response => onClose(response.data))
            .catch(e => MprcRequestSnackbarErrorReport(e))
            .finally(() => onClose(false));
    }, []);

    return <MprcRequestIndicator visible type={"post"} />;
};


export const EditProgressBox: React.FC<IProps> = ({ devPlanItemId, currentProgress, readonly, onReload }) => {


    const [progress, setProgress] = useState<number | undefined>(currentProgress);
    const [saving, setSaving] = useState<boolean>(false);

    const isChanged = progress != currentProgress;

    return (
        <Box sx={theme =>
        (
            {
                bgcolor: theme.palette.notice.light,
                borderRadius: "10px",
                p: 0.5,
                pr: 1,
                width: "200px"
            }
        )}>
            <Stack justifyContent="flex-end" alignItems="center">
                {saving &&
                    <UpdateOtherActivityProgress
                        devPlanItemId={devPlanItemId}
                        progress={progress ?? 0}
                        onClose={(success) => {
                            if (success && onReload) onReload();
                            setSaving(false);
                        }}
                    />
                }
                {!readonly && !isChanged && <Typography variant="caption">{(currentProgress ?? 0) == 0 ? "Informe seu progresso" : "Atualize seu progresso"}</Typography>}
                <Stack direction="row" alignItems="center" width="100%">
                    <Slider
                        value={progress}
                        disabled={saving || readonly}
                        defaultValue={0}
                        min={0}
                        max={100}
                        disableSwap={readonly}
                        valueLabelDisplay="off"
                        onChange={(e, value) => setProgress(value as number)}
                        sx={{ mx: 2, width: "100%" }}
                    />
                    <Typography variant="overline">{progress ?? 0}%</Typography>
                </Stack>
                <Stack direction="row" justifyContent="flex-end" width="100%">
                    {!readonly && isChanged &&
                        <ButtonConfirm
                            disabled={saving}
                            variant="contained"
                            fullWidth={false}
                            size="small"
                            sx={{ m: 0 }}
                            onClick={() => setSaving(true)}
                        />
                    }
                </Stack>
            </Stack>
        </Box>
    );
};
